import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-table channel" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("配置菜单")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_table = _resolveComponent("a-table")
  const _component_set_menu = _resolveComponent("set-menu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_table, {
      columns: _ctx.columns,
      "data-source": _ctx.data,
      loading: _ctx.loading,
      pagination: _ctx.pagination,
      ref: "tableElRef",
      "row-key": (record) => record.id
    }, {
      action: _withCtx(({ record }) => [
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.configMenuAction(record))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading", "pagination", "row-key"]),
    (_ctx.store.state.role.setMenuState)
      ? (_openBlock(), _createBlock(_component_set_menu, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}